import { CenterUserList } from "../helper/type";
import {  User} from "oidc-client-ts";

// Todo refacto :
// - changement en class : quelle est la bonne ou mauvaise pratique ?
// - Convention de nommage (member)

class FrontUser {
  sub?: string;
  familyName?: string;
  givenName?: string;
  email: string;
  emailVerified: boolean;
  roles: string[];
  scopes?: string[] ;
  expired: boolean | undefined;
  centersUser: CenterUserList[];
  picture: string;
  codeSite_chefdecentre: string[];
  codesite: string[];
  displayName: string;
  expiresAt?: number;
  accessToken: string;
  constructor(oidcUser: User) {
    this.sub = oidcUser.profile.sub;
    this.familyName = oidcUser.profile.family_name;
    this.givenName = oidcUser.profile.given_name;
    this.email = oidcUser.profile.email || "";
    this.emailVerified = oidcUser.profile.email_verified?? false;
    this.roles = Array.isArray(oidcUser.profile.role) ? oidcUser.profile.role : [oidcUser.profile.role];
    this.scopes = oidcUser.scopes? (Array.isArray(oidcUser.scopes) ? oidcUser.scopes : [oidcUser.scopes]) : undefined;
    this.expired = oidcUser.expired;
    this.centersUser = [];
    this.picture = oidcUser.profile.picture ?? "/images/userprofile.svg";
    this.codeSite_chefdecentre = oidcUser.profile.GDPORC_chefdecentre_codesite? (Array.isArray(oidcUser.profile.GDPORC_chefdecentre_codesite) ? oidcUser.profile.GDPORC_chefdecentre_codesite : [oidcUser.profile.GDPORC_chefdecentre_codesite]) : [];
    this.codesite = oidcUser.profile.GDPORC_codesite ? (Array.isArray(oidcUser.profile.GDPORC_codesite) ? oidcUser.profile.GDPORC_codesite : [oidcUser.profile.GDPORC_codesite]) : [];
    this.displayName = this.givenName + " " + this.familyName;
    this.expiresAt = oidcUser.expires_at;
    this.accessToken = oidcUser.access_token;
  }
}


export { FrontUser };
